module.exports = __webpack_public_path__ + "img/banner3.b10470c0.jpg";